import axios, { AxiosResponse } from 'axios'
import { ArquivoDto } from '../../../apps/atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL

const SCREENING_PUBLIC_URL = `${API_URL}/public/screening`
const ASO_PUBLIC_URL = `${API_URL}/public/aso`

/**
 * Screening - Download do relatório de atendimento
 * @param protocolo string
 * @param documento CPF/CNS
 * @returns
 */
export const downloadScreeningRelatorio = (
  protocolo: string,
  documento: string
): Promise<ArquivoDto> => {
  return axios
    .get(`${SCREENING_PUBLIC_URL}/${protocolo}?documento=${documento}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * ASO - Download do relatório de atendimento
 * @param protocolo string
 * @param documento CPF/CNS
 * @returns
 */
export const downloadAsoRelatorio = (protocolo: string, documento: string): Promise<ArquivoDto> => {
  return axios
    .get(`${ASO_PUBLIC_URL}/${protocolo}?documento=${documento}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}
